import apiClient from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_REST_API_VSMS

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: '/industry-category',
    params: params,
  })

  return response?.data
}
